import { SharedModule } from '../../shared/shared.module';
import { CagnottesComponent } from './cagnottes.component';
import {NgModule} from '@angular/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { CagnottesDetailsModule } from './cagnottes-details/cagnottes-details.module';
import { CagnottesListModule } from './cagnottes-list/cagnottes-list.module';
import { CagnottesViewModule } from './cagnottes-view/cagnottes-view.module';
import { BsDatepickerModule } from 'ngx-bootstrap';


@NgModule({
  imports: [
    NgbModule,
    SharedModule,
    CagnottesDetailsModule,
    CagnottesListModule,
    CagnottesViewModule,
    BsDatepickerModule
  ],
  declarations: [CagnottesComponent],
  exports: [CagnottesComponent]
})
export class CagnottesModule {}
